import Address from './address';

export default class userProfile {
  constructor() {
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.secondaryEmail = '';
    this.socialSecurityNum = '';
    this.primaryPhoneNum = '';
    this.secondaryPhoneNum = '';
    this.dateOfBirth = null;
    this.residentialAddress = new Address();
    this.isResidentDefaultAddress = true;
    this.mailingAddress = new Address();
    this.accountType = 'INDIVIDUAL';
    this.accounts = [];
    this.roles = [];
    this.status = '';
    this.userType = 'INVESTOR';
    this.CRDnumber = '';
    this.organizationName = '';
    this.alternateCompanyName = '';
    this.updateCount = 0;
  }
}



// WEBPACK FOOTER //
// ./src/entities/userProfile.js